export enum ActionParamPlaceHolder {
  FromState,
  NotDefined,
}

export interface Coordinates {
  lat: number
  lng: number
}

export interface UserPosition {
  coordinates: Coordinates | null
  accuracy: number | null
}
